import { Component, OnInit } from '@angular/core';
import { environment } from '../../environments/environment';
import { ProcessService } from '../data/process.service';
import { LocationService } from '../util/location.service';
import { first, map } from 'rxjs/operators';
import { Observable } from 'rxjs';

const learnTokenProcessTip = 'eim/process/learn/generate-learn-token';

@Component({
  selector: 'app-learn',
  templateUrl: './learn.component.html',
  styleUrls: ['./learn.component.scss']
})
export class LearnComponent implements OnInit {

  enCloudEnv = environment.enCloudEnv;

  constructor(
    private processService: ProcessService,
    private locationService: LocationService
  ) { }

  ngOnInit() {
    this.getLearnUri().subscribe(
      redirectUri => this.locationService.redirect(redirectUri),
      _ => {
        this.locationService.redirect(this.environmentLearnUri(environment.learn.homeUrl));
      }
    );
  }

  getLearnUri(): Observable<string> {
    return this.processService.start(learnTokenProcessTip).pipe(
      first(),
      map(response => {
        if (response.finished && response.vars.responseToken && response.vars.responseToken[0]) {
          return this.environmentLearnUri(environment.learn.tokenUrl)
                  + '?serviceUrl=' + escape(environment.host)
                  + '&namespace=' + escape(environment.ns)
                  + '&token=' + escape(response.vars.responseToken[0]);
        }
        return this.environmentLearnUri(environment.learn.homeUrl);
      })
    );
  }

  environmentLearnUri(learnUri: string): string {
    switch (this.enCloudEnv) {
      case 'aupr':
        // To avoid having to rebuild the entire app just for AUPR, we rewrite the learn portal url
        return learnUri.replace(/learn\.noggin\.io/, 'learn.aupr.elasticnoggin.com');
      case 'test':
        return learnUri.replace(/learn/, 'learn-test');
      case 'dev':
      case 'development':
        return learnUri.replace(/learn/, 'learn-dev');
    }
    return learnUri;
  }

}
